<p-confirmpopup #confirmPopup appendTo="body" [styleClass]="confirmationClass()">
    <ng-template #headless let-message>
      <div class="rounded p-4">
        <div class="flex flex-col gap-3 mb-3">
          <ng-icon [name]="confirmationIcon()" size="24"></ng-icon>
          <span class="font-medium">{{ confirmationMessage() }}</span>
        </div>
        <div class="flex items-center justify-end gap-2 mt-4">
          @if (confirmationShowAcceptButton()) {
          <app-button 
            appClickStopPropagation
            [isSaving]="isSaving()"
            [disabled]="isSaving()"
            [size]="'small'"
            fillMode="solid"
            [color]="'primary'"
            (click)="confirmationHandleSaving() ? onAcceptClick() : confirmPopup.onAccept()">
            {{ confirmationAcceptLabel() }}
          </app-button> 
          }
          @if (confirmationShowRejectButton()) {
          <app-button 
            [disabled]="isSaving()"
            [size]="'small'"
            fillMode="outline"
            [color]="'secondary'"
            (click)="confirmPopup.onReject()">
            {{ confirmationRejectLabel() }}
          </app-button>
          }
        </div>
      </div>
    </ng-template>
  </p-confirmpopup>